import { createFileRoute } from "@tanstack/react-router";
import { ASSETS } from "#/lib/assets";
import { PillHero } from "../components/PillHero.js";

export const Route = createFileRoute("/returns")({
  head: () => ({ meta: [{ title: "Returns" }] }),
  component: ReturnsPage,
});

function ReturnsPage() {
  return (
    <div data-screen-label="Returns & Refunds" className="pb-24">
      <PillHero
        content={
          <h1 className="m-0 whitespace-pre-line font-bold font-display text-5xl text-lp-green-dk leading-[1.05] md:text-6xl">
            {"RETURNS &\nREFUNDS"}
          </h1>
        }
        asset={
          <img
            src={ASSETS.heroReturns}
            alt=""
            className="h-56 w-auto object-cover md:h-96"
          />
        }
        assetClassName="md:-mb-20 md:-my-40 md:-ml-0 md:-mr-54"
        pillClassName="md:mt-20"
      />

      <div className="mx-auto mt-12 w-full max-w-4xl px-6 md:px-10">
        <section className="mb-10">
          <h2 className="m-0 mb-5 font-display font-semibold text-xl text-lp-green-dk">
            1. Return Policy
          </h2>
          <div className="space-y-4 font-display text-base text-lp-text-dk leading-relaxed">
            <p className="m-0">
              <span className="font-semibold">1.1</span> All items are carefully
              and thoroughly inspected prior to shipping. In any rare case that
              the item delivered is damaged or faulty, please email
              orders@learningplus.ph within 7 days upon receipt of the package.
            </p>
            <div>
              <p className="m-0">
                <span className="font-semibold">1.2</span> Shipping cost
                incurred to return the goods will be shouldered by the customer.
              </p>
              <ul className="mt-2 list-disc pl-8">
                <li>
                  Official receipts must be presented for cancellation and must
                  be re-attached to the book/s to be returned. A new Official
                  Receipt will be issued, with the corrected amount due. In
                  cases where there is no change in the total amount paid, the
                  original receipt may be re-attached upon delivery of the new
                  book.
                </li>
              </ul>
            </div>
            <div>
              <p className="m-0">
                <span className="font-semibold">1.3</span> Incomplete or Missing
                item
              </p>
              <ul className="mt-2 list-disc space-y-2 pl-8">
                <li>
                  Once you have received the package, please check to confirm
                  that you have received ALL items that are listed on the
                  Booklist. The booklist is also inside your parcel for your
                  reference.
                </li>
                <li>
                  It is your duty to check and confirm if there are missing or
                  wrong books delivered within 7 days from the delivery date of
                  your order.
                </li>
                <li>
                  Please email orders@learningplus.ph within 7 days from the
                  delivery date if you have confirmed that you have received a
                  missing item or incorrect book.
                </li>
                <li>
                  Include the following details in your email:
                  <ul className="mt-1 list-[circle] space-y-1 pl-6">
                    <li>Image of All the books/Item(s) received</li>
                    <li>Order Number</li>
                    <li>Date received</li>
                  </ul>
                </li>
              </ul>
            </div>
            <p className="m-0">
              <span className="font-semibold">1.4</span> Sale, discounted items,
              online classes, e-books, Quipper, Online Group Tutorials, and
              promo items are considered final, non-exchangeable, and
              non-refundable.
            </p>
            <p className="m-0">
              <span className="font-semibold">1.5</span> We will not be held
              liable for any damage, delay, or loss that occurs due to courier
              handling once the package has been handed over for delivery.
            </p>
            <p className="m-0">
              <span className="font-semibold">1.6</span> Once we have confirmed
              that the item is eligible for return, the customer must ship and
              ensure the item is delivered back to us within 7 days from the
              date of our confirmation. Returns not received within this 7-day
              window will be considered forfeited and no refund or exchange will
              be processed.
            </p>
          </div>
        </section>

        <section className="mb-10">
          <h2 className="m-0 mb-5 font-display font-semibold text-xl text-lp-green-dk">
            2. Disapproved reasons for return/refund
          </h2>
          <div className="space-y-2 font-display text-base text-lp-text-dk leading-relaxed">
            <p className="m-0">
              <span className="font-semibold">2.1</span> Change of mind
            </p>
            <p className="m-0">
              <span className="font-semibold">2.2</span> Disappointment with the
              book/s
            </p>
            <p className="m-0">
              <span className="font-semibold">2.3</span> Incorrect/mistakenly
              ordered book, e-book, Online Group Tutorials.
            </p>
            <p className="m-0">
              <span className="font-semibold">2.4</span> Change of Program
            </p>
          </div>
        </section>

        <section>
          <h2 className="m-0 mb-5 font-display font-semibold text-xl text-lp-green-dk">
            3. Refund Policy
          </h2>
          <p className="m-0 font-display text-base text-lp-text-dk leading-relaxed">
            <span className="font-semibold">3.1</span> We will process your
            refund within 60 banking days from the date your request is
            confirmed via Bank Transfer.
          </p>
        </section>
      </div>
    </div>
  );
}
